export default __webpack_public_path__ + "static/media/header.083a11be.png";